import React from "react";
import {
  DISTRIBUTOR_COVETRUS,
  DISTRIBUTOR_PATTERSON,
  DISTRIBUTOR_MIDWEST,
  DISTRIBUTOR_MWI,
  distributorSlugToName,
} from "@src/constants/Distributors";
import DistributorLogoThemes from "./DistributorLogoThemes";
import PattersonLogo from "@src/components/common/DistributorLogo/PattersonLogo";
import CovetrusLogo from "@src/components/common/DistributorLogo/CovetrusLogo";
import MidwestVeterinarySupplyLogo from "@src/components/common/DistributorLogo/MidwestVeterinarySupplyLogo";
import MWIAnimalHealthLogo from "@src/components/common/DistributorLogo/MWIAnimalHealthLogo";

export interface BaseDistributorLogoProps {
  className?: string;
  width?: number;
  height?: number;
  theme?: string;
}

interface DistributorLogoProps extends BaseDistributorLogoProps {
  distributorSlug: string;
  ariaLabel?: string;
}

const getDistributorLogoComponent = (distributorSlug: string) => {
  switch (distributorSlug) {
    case DISTRIBUTOR_PATTERSON:
      return PattersonLogo;
    case DISTRIBUTOR_COVETRUS:
      return CovetrusLogo;
    case DISTRIBUTOR_MIDWEST:
      return MidwestVeterinarySupplyLogo;
    case DISTRIBUTOR_MWI:
      return MWIAnimalHealthLogo;
    default:
      return null;
  }
};

export default function DistributorLogo({
  distributorSlug,
  className,
  width,
  height = 24,
  theme = DistributorLogoThemes.Default,
  ariaLabel,
}: DistributorLogoProps): React.JSX.Element | null {
  const DistributorLogoComponent = getDistributorLogoComponent(distributorSlug);
  if (!DistributorLogoComponent) {
    return <span>Distributor logo '{distributorSlug}' not supported</span>;
  }
  const resolvedAriaLabel =
    ariaLabel ?? `${distributorSlugToName(distributorSlug)} logo`;
  return (
    <span role="img" aria-label={resolvedAriaLabel}>
      <DistributorLogoComponent
        className={className}
        width={width}
        height={height}
        theme={theme}
      />
    </span>
  );
}
